import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper/modules";
import "swiper/css";

export const slider = (): void => {
  console.log("slider");

  const topImageSlider = new Swiper(".p-top-about-slider__swiper", {
    modules: [Autoplay, EffectFade],
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    effect: "fade",
    speed: 2000,
  });

  const topPlacesSlider = new Swiper(".p-top-places-list__swiper", {
    modules: [Autoplay, Navigation],
    loop: true,
    slidesPerView: 5,
    centeredSlides: true,
    spaceBetween: 20,
    speed: 1000,
    autoplay: {
      delay: 20000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".p-top-places-list__btn.--next",
      prevEl: ".p-top-places-list__btn.--prev",
    },
    breakpoints: {
      980: {
        slidesPerView: 5,
      },
      850: {
        slidesPerView: 4,
      },
      576: {
        slidesPerView: 3,
      },
      375: {
        slidesPerView: 1.4,
      },
      320: {
        slidesPerView: 1,
      },
    },
  });

  const aboutSlider = new Swiper(".p-about-slider__swiper", {
    modules: [Autoplay],
    loop: true,
    slidesPerView: 3, // ← SCSSで幅指定するので auto 的なノリ
    spaceBetween: 30,
    speed: 800,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });

  // ==============================
  // Products overview slider
  // ==============================
  const productsOverviewEl = document.querySelector(".p-products-overview .swiper");

  if (productsOverviewEl) {
    const productsOverviewSlider = new Swiper(".p-products-overview .swiper", {
      modules: [Autoplay, Pagination],
      loop: true,
      slidesPerView: 1,
      speed: 1000,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".p-products-overview .swiper-pagination",
        clickable: true,
      },
    });
    // console.log(productsOverviewSlider); // デバッグ用に必要なら
  }
};
